import React from "react";
import Button from "../Button/Button";
import TinyEditor from "../TextEditor/Editor";
import "./FaqSection.css";

const FaqSection = ({
  value = [],
  onChange,
  label = "FAQs",
  remountKey = "",
}) => {
  const normalizeFaqs = (rawFaqs) => {
    if (!Array.isArray(rawFaqs)) return [];

    return rawFaqs.flatMap((item) => {
      if (Array.isArray(item?.qa)) {
        return item.qa.map((qa) => ({
          question: qa?.question || "",
          answer: qa?.answer || "",
        }));
      }

      if (typeof item === "object" && item !== null) {
        return [
          {
            question: item?.question || "",
            answer: item?.answer || "",
          },
        ];
      }

      return [];
    });
  };

  const faqs = normalizeFaqs(value);

  const emit = (next) => {
    if (typeof onChange === "function") onChange(next);
  };

  const addQA = () => {
    emit([...faqs, { question: "", answer: "" }]);
  };

  const removeQA = (qaIdx) => {
    emit(faqs.filter((_, index) => index !== qaIdx));
  };

  const handleEditorChange = (qaIdx, field, content) => {
    const next = faqs.map((qa, index) =>
      index === qaIdx ? { ...qa, [field]: content } : qa
    );
    emit(next);
  };

  return (
    <div className="faqSection">
      <label className="faqSectionLabel">{label}</label>

      {faqs.map((qa, qaIdx) => (
        <div className="faqQAItem" key={`${remountKey}-row-${qaIdx}`}>
          <div className="faqQAItemHeader">
            <span>Q&A #{qaIdx + 1}</span>
            <Button
              className={"RedFillButton faqRemoveBtn small"}
              name={"Remove"}
              onClick={() => removeQA(qaIdx)}
            />
          </div>

          <div className="faqEditorBlock faqEditorShell">
            <label className="faqFieldLabel">Question</label>
            <TinyEditor
              key={`faq-q-${remountKey}-${qaIdx}`}
              initialValue={qa?.question || ""}
              onChange={(content) => handleEditorChange(qaIdx, "question", content)}
              height={200}
              pasteAsText={true}
            />
          </div>

          <div className="faqEditorBlock faqEditorShell">
            <label className="faqFieldLabel">Answer</label>
            <TinyEditor
              key={`faq-a-${remountKey}-${qaIdx}`}
              initialValue={qa?.answer || ""}
              onChange={(content) => handleEditorChange(qaIdx, "answer", content)}
              height={260}
              pasteAsText={true}
            />
          </div>
        </div>
      ))}

      <div className="faqAddTitleWrap">
        <Button
          className={"BlueFillButton faqAddTitleBtn"}
          name={"+ Add Question & Answer"}
          onClick={addQA}
        />
      </div>
    </div>
  );
};

export default FaqSection;
